/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrderTypeAdditionalServiceCreateReqVo
 */
export interface OrderTypeAdditionalServiceCreateReqVo {
    /**
     * 订单类型
     * @type {number}
     * @memberof OrderTypeAdditionalServiceCreateReqVo
     */
    orderType: number;
    /**
     * 订单类型的附加服务组id [1,2,3,4]
     * @type {Array<number>}
     * @memberof OrderTypeAdditionalServiceCreateReqVo
     */
    additionalServiceGroups: Array<number>;
    /**
     * 是否可用 0 不可用，1 可用
     * @type {number}
     * @memberof OrderTypeAdditionalServiceCreateReqVo
     */
    enable: number;
    /**
     * 订单类型必选附加服务 [5,6,7,8]
     * @type {Array<number>}
     * @memberof OrderTypeAdditionalServiceCreateReqVo
     */
    mustCheckServices?: Array<number>;
    /**
     * 仓库id
     * @type {number}
     * @memberof OrderTypeAdditionalServiceCreateReqVo
     */
    warehouseId: number;
}

/**
 * Check if a given object implements the OrderTypeAdditionalServiceCreateReqVo interface.
 */
export function instanceOfOrderTypeAdditionalServiceCreateReqVo(value: object): value is OrderTypeAdditionalServiceCreateReqVo {
    if (!('orderType' in value) || value['orderType'] === undefined) return false;
    if (!('additionalServiceGroups' in value) || value['additionalServiceGroups'] === undefined) return false;
    if (!('enable' in value) || value['enable'] === undefined) return false;
    if (!('warehouseId' in value) || value['warehouseId'] === undefined) return false;
    return true;
}

export function OrderTypeAdditionalServiceCreateReqVoFromJSON(json: any): OrderTypeAdditionalServiceCreateReqVo {
    return OrderTypeAdditionalServiceCreateReqVoFromJSONTyped(json, false);
}

export function OrderTypeAdditionalServiceCreateReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderTypeAdditionalServiceCreateReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'orderType': json['orderType'],
        'additionalServiceGroups': json['additionalServiceGroups'],
        'enable': json['enable'],
        'mustCheckServices': json['mustCheckServices'] == null ? undefined : json['mustCheckServices'],
        'warehouseId': json['warehouseId'],
    };
}

export function OrderTypeAdditionalServiceCreateReqVoToJSON(json: any): OrderTypeAdditionalServiceCreateReqVo {
    return OrderTypeAdditionalServiceCreateReqVoToJSONTyped(json, false);
}

export function OrderTypeAdditionalServiceCreateReqVoToJSONTyped(value?: OrderTypeAdditionalServiceCreateReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'orderType': value['orderType'],
        'additionalServiceGroups': value['additionalServiceGroups'],
        'enable': value['enable'],
        'mustCheckServices': value['mustCheckServices'],
        'warehouseId': value['warehouseId'],
    };
}

